import { defineMigrations } from '@tldraw/tldraw'

export const Versions = {
  AddFillOpacityProp: 1,
  AddShadowProp: 2,
  AddFillGradientProp: 3,
  AddFillProp: 4,
  DeleteFillColorFillOpacityFillGradientProps: 5,
  AddIsEditableProp: 6,
  AddIsAutoUpdatableProp: 7,
} as const

export const geoShapeMigrations = defineMigrations({
  currentVersion: Versions.AddIsAutoUpdatableProp,
  migrators: {
    [Versions.AddFillOpacityProp]: {
      up: (shape) => {
        return {
          ...shape,
          props: {
            ...shape.props,
            fillOpacity: 1,
          },
        }
      },
      down: (shape) => {
        const { fillOpacity: _, ...props } = shape.props
        return { ...shape, props }
      },
    },
    [Versions.AddShadowProp]: {
      up: (shape) => {
        return {
          ...shape,
          props: {
            ...shape.props,
            shadow: null,
          },
        }
      },
      down: (shape) => {
        const { shadow: _, ...props } = shape.props
        return { ...shape, props }
      },
    },
    [Versions.AddFillGradientProp]: {
      up: (shape) => {
        return {
          ...shape,
          props: {
            ...shape.props,
            fillGradient: null,
          },
        }
      },
      down: (shape) => {
        const { fillGradient: _, ...props } = shape.props
        return { ...shape, props }
      },
    },
    [Versions.AddFillProp]: {
      up: (shape) => {
        return {
          ...shape,
          props: {
            ...shape.props,
            fill: shape.props.fillGradient
              ? {
                  type: 'linearGradient',
                  ...shape.props.fillGradient,
                }
              : {
                  type: 'solidColor',
                  color: shape.props.fillColor,
                  opacity: shape.props.fillOpacity,
                },
          },
        }
      },
      down: (shape) => {
        const { fill, ...props } = shape.props
        return {
          ...shape,
          props: {
            ...props,
            fillColor: fill.type === 'solidColor' ? fill.color : props.fillColor,
            fillOpacity: fill.type === 'solidColor' ? fill.opacity : props.fillOpacity,
            fillGradient:
              fill.type === 'linearGradient'
                ? {
                    angle: fill.angle,
                    stops: fill.stops,
                  }
                : props.fillGradient,
          },
        }
      },
    },
    [Versions.DeleteFillColorFillOpacityFillGradientProps]: {
      up: (shape) => {
        const { fillColor: _, fillOpacity: __, fillGradient: ___, ...props } = shape.props
        return { ...shape, props }
      },
      down: (shape) => {
        return {
          ...shape,
          props: {
            ...shape.props,
            fillColor: '#000000',
            fillOpacity: 1,
            fillGradient: null,
          },
        }
      },
    },
    [Versions.AddIsEditableProp]: {
      up: (shape) => {
        return { ...shape, props: { ...shape.props, isEditable: true } }
      },
      down: (shape) => {
        const { isEditable: _, ...props } = shape.props
        return { ...shape, props }
      },
    },
    [Versions.AddIsAutoUpdatableProp]: {
      up: (shape) => {
        return {
          ...shape,
          props: {
            ...shape.props,
            isAutoUpdatable: true,
          },
        }
      },
      down: (shape) => {
        const { isAutoUpdatable: _, ...props } = shape.props
        return { ...shape, props }
      },
    },
  },
})
